import axios from '@/libs/api.request';

export const getRefundList = data => {
    return axios.request({
        url: 'web/saleManagement/refundGoods/getPageRefundList',
        data: data,
        method: 'post'
    });
};

export const getRefundInfo = data => {
    return axios.request({
        url: 'api/saleManagement/refundGoods/getRefundInfo',
        data: data,
        method: 'post'
    });
};

export const saveRefundGoods = data => {
    return axios.request({
        url: 'api/saleManagement/refund/saveRefundGoods',
        data: data,
        method: 'post'
    });
};

export const getRefundGoodsInfo = data => {
    return axios.request({
        url: 'api/saleManagement/refundGoods/getRefundInfo',
        data: data,
        method: 'post'
    });
};

export const getReturnOrderList = data => {
    return axios.request({
        url: 'web/saleManagement/refundGoods/getPageRefundList',
        data: data,
        method: 'post'
    });
};
